var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcons01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 73.6672C58.8916 73.6672 74.6116 58.1462 74.6116 39.0001C74.6116 19.854 58.8916 4.33301 39.5 4.33301C20.1084 4.33301 4.38846 19.854 4.38846 39.0001C4.38846 58.1462 20.1084 73.6672 39.5 73.6672Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0792 36.4753C31.1497 42.4254 36.053 47.2614 42.0846 50.2878L46.7614 45.6611C47.3473 45.0826 48.1834 44.9175 48.9194 45.1476C51.2934 45.9224 53.8569 46.3436 56.5021 46.3436C57.6805 46.3436 58.6272 47.2783 58.6272 48.4418V55.7855C58.6272 56.949 57.6805 57.8837 56.5021 57.8837C36.5467 57.8837 20.3767 41.9184 20.3767 22.2156C20.3767 21.0573 21.3287 20.1174 22.5018 20.1174H29.9397C31.1181 20.1174 32.0648 21.0521 32.0648 22.2156C32.0648 24.8273 32.4914 27.3571 33.2761 29.7062C33.5105 30.4277 33.3433 31.2584 32.756 31.8382L28.0806 36.4766L28.0792 36.4753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcons01);
export default __webpack_public_path__ + "static/media/contact_icons-01.d64ae1778203176735a089d55de93ff0.svg";
export { ForwardRef as ReactComponent };